import { create } from 'zustand';
import { DestinationValue } from '../../types/cms';
import { devtools, persist } from 'zustand/middleware';

interface CmsStore {
  destinationValue: DestinationValue | null;
  updateDestinationValue: (destinationValue: DestinationValue) => void;
}

const useCmsStore = create<CmsStore>()(
  devtools(
    persist(
      (set) => ({
        destinationValue: null,
        updateDestinationValue: (destinationValue: DestinationValue) =>
          set(() => ({ destinationValue })),
      }),
      {
        name: 'cms-store',
      },
    ),
  ),
);

export default useCmsStore;
